export default {
  methods: {
    captureFileListScroll(superiorId, courseClassifyId) {
      if (!this.editFormVisibleFile ||
          this.courseData.superiorId !== superiorId ||
          this.courseData.courseClassifyId !== courseClassifyId) {
        return null;
      }

      const dialog = this.$refs.fileDataDialog;
      const table = this.$refs.fileDataTable;
      return {
        superiorId,
        courseClassifyId,
        top: dialog ? dialog.$el.scrollTop : 0,
        left: table && table.bodyWrapper ? table.bodyWrapper.scrollLeft : 0,
      };
    },
    restoreFileListScroll(position) {
      if (!this.editFormVisibleFile || (position &&
          (this.courseData.superiorId !== position.superiorId ||
           this.courseData.courseClassifyId !== position.courseClassifyId))) {
        return;
      }

      const dialog = this.$refs.fileDataDialog;
      const table = this.$refs.fileDataTable;
      if (dialog) {
        dialog.$el.scrollTop = position ? position.top : 0;
      }
      if (table && table.bodyWrapper) {
        table.bodyWrapper.scrollLeft = position ? position.left : 0;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/courseFileListScroll.js